/* eslint-disable */
import * as Types from '../../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetUserZoneFollowsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetUserZoneFollowsQuery = { __typename: 'Query', getUserLabelFollows: Array<{ __typename: 'LabelFollow', id: string | null, user_id: string | null, label_id: string | null } | null> | null };


export const GetUserZoneFollowsDocument = gql`
    query getUserZoneFollows {
  getUserLabelFollows {
    id
    user_id
    label_id
  }
}
    `;

/**
 * __useGetUserZoneFollowsQuery__
 *
 * To run a query within a React component, call `useGetUserZoneFollowsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserZoneFollowsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserZoneFollowsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserZoneFollowsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserZoneFollowsQuery, GetUserZoneFollowsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserZoneFollowsQuery, GetUserZoneFollowsQueryVariables>(GetUserZoneFollowsDocument, options);
      }
export function useGetUserZoneFollowsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserZoneFollowsQuery, GetUserZoneFollowsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserZoneFollowsQuery, GetUserZoneFollowsQueryVariables>(GetUserZoneFollowsDocument, options);
        }
export type GetUserZoneFollowsQueryHookResult = ReturnType<typeof useGetUserZoneFollowsQuery>;
export type GetUserZoneFollowsLazyQueryHookResult = ReturnType<typeof useGetUserZoneFollowsLazyQuery>;